import * as React from 'react';
import { action, observable, observe } from 'mobx';
import { inject, observer } from 'mobx-react';

// Services
import { getStatistics } from '../../services/statistic';

// Types
import { IStore } from '../../store/Store';
import { ITagQuery } from '../AppNetworkPeople/AppNetworkPeople';

// Components
import Box from '../../components/Box';
import { BarChart } from '../../components/Chart';
import Container from '../../components/Container';
import Paper from '../../components/Paper';
import Toolbar from '../../components/Toolbar';
import Typography from '../../components/Typography';

// Component
interface IProps {
  store?: IStore;
  tagQuery: ITagQuery[];
  parentTag: { tagId: string };
}

class AppNetworkStatistics extends React.Component<IProps, {}> {
  chartOptions = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };
  chartColor: string = 'rgba(255, 74, 93, 0.8)';
  chartLabel: string = '# of People';
  chartBorderWidth: number = 1;
  @observable.ref
  statisticData = {
    labels: ['No Data'],
    datasets: [
      {
        label: this.chartLabel,
        data: [0],
        backgroundColor: this.chartColor,
        borderWidth: this.chartBorderWidth
      }
    ]
  };

  tagQueryDisposer: () => void;
  parentTagDisposer: () => void;

  componentDidMount() {
    this.getStatistic();
    this.tagQueryDisposer = observe(this.props.tagQuery, this.getStatistic);
    this.parentTagDisposer = observe(this.props.parentTag, this.getStatistic);
  }

  @action
  getStatistic = async () => {
    if (this.props.parentTag) {
      const stats = await getStatistics({
        params: {
          networkId: this.props.store!.networkStore.network!.networkId
        },
        query: {
          tagId: this.props.parentTag.tagId,
          filterTagIds: this.props.tagQuery.map(item => item.tagId).join(',')
        }
      });
      this.statisticData = {
        labels: stats.map(item => item.name),
        datasets: [
          {
            label: this.chartLabel,
            data: stats.map(item => item.people),
            backgroundColor: this.chartColor,
            borderWidth: this.chartBorderWidth
          }
        ]
      };
    } else {
      this.statisticData = {
        labels: ['No Data'],
        datasets: [
          {
            label: this.chartLabel,
            data: [0],
            backgroundColor: this.chartColor,
            borderWidth: this.chartBorderWidth
          }
        ]
      };
    }
  };

  componentWillUnmount() {
    this.tagQueryDisposer();
    this.parentTagDisposer();
  }

  render() {
    return (
      <Container size="lg" padded={true}>
        <Paper>
          <Toolbar style={{ height: 56 }}>
            <Typography type="title">Statistics</Typography>
          </Toolbar>
          <Box px={4} pb={4}>
            <BarChart
              data={this.statisticData}
              height={280}
              options={this.chartOptions}
            />
          </Box>
        </Paper>
      </Container>
    );
  }
}

export default inject('store')(observer(AppNetworkStatistics));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleStatistics/AppNetworkPeopleStatistics.tsx